import * as tslib_1 from "tslib";
import { ContextFlash } from "./ContextFlash";
import { OpCodes } from "./OpCodes";
import { ResourceBaseFlash } from "./ResourceBaseFlash";
var ProgramFlash = (function (_super) {
    tslib_1.__extends(ProgramFlash, _super);
    function ProgramFlash(context) {
        var _this = _super.call(this) || this;
        _this._context = context;
        _this._context.addStream(String.fromCharCode(OpCodes.initProgram));
        _this._pId = _this._context.execute();
        _this._context._iAddResource(_this);
        return _this;
    }
    ProgramFlash.prototype.upload = function (vertexProgram, fragmentProgram) {
        this._context.addStream(String.fromCharCode(OpCodes.uploadAGALBytesProgram, this._pId + OpCodes.intMask) + vertexProgram.readBase64String(vertexProgram.length) + "%" + fragmentProgram.readBase64String(fragmentProgram.length) + "%");
        if (ContextFlash.debug)
            this._context.execute();
    };
    ProgramFlash.prototype.dispose = function () {
        this._context.addStream(String.fromCharCode(OpCodes.disposeProgram, this._pId + OpCodes.intMask));
        this._context.execute();
        this._context._iRemoveResource(this);
        this._context = null;
    };
    return ProgramFlash;
}(ResourceBaseFlash));
export { ProgramFlash };



// WEBPACK FOOTER //
// ../dist/lib/flash/ProgramFlash.js